import React from 'react';
import { Skeleton } from 'antd';
import { useGetManyCargos } from 'api/cargos/use-get-many-cargos.ts';
import { useStatePagination } from 'shared/hooks/use-state-pagination.ts';
import { CargosList } from 'components/cargos/cargos-list';
import { Pagination } from 'components/pagination';

interface IOrderCargosProps {
  orderId: number;
}

export const OrderCargos: React.FC<IOrderCargosProps> = (props) => {
  const { orderId } = props;

  const { page, limit, handlePageChange } = useStatePagination({ defaultLimit: 20 });

  const {
    data: cargos,
    isLoading,
    isPreviousData,
  } = useGetManyCargos({
    page,
    limit,
    filters: { orderId },
  });

  return (
    <Skeleton loading={isLoading}>
      <CargosList
        cargos={cargos?.data || []}
        isLoading={isPreviousData}
        withoutClient
        withoutOrder
        withoutSelect
        withoutSummary
      />
      <Pagination total={cargos?.pagination?.total} page={page} limit={limit} onChange={handlePageChange} />
    </Skeleton>
  );
};
